export default "__VITE_ASSET__5a422007__"